module.exports = __webpack_public_path__ + "static/media/trn-surprise.ac614d29.png";